import { Search } from "@mui/icons-material";
import { Box, Button, Chip, InputBase, Skeleton } from "@mui/material";
import { homepageApi } from "features/homepage/homepageApi";
import { IKeywordSuggest } from "features/homepage/models";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { IValueLabel } from "utils/commonModels";
import { ISearchFilter } from "../models";
import { selectFilter, searchStoreActions } from "../saga/searchStoreSlice";

function SuggestSearchBar() {
  const dispatch = useAppDispatch();

  const filter = useAppSelector(selectFilter);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyWord] = useState<IValueLabel<string>>({
    value: "",
    label: "",
  });
  const [suggests, setSuggests] = useState<IKeywordSuggest[]>([]);
  const [keywordSend, setKeyWordSend] = useState<string>("");

  const handleSearchClick = () => {
    const filterValue: ISearchFilter = {
      ...filter,
      keyword: keyword,
    };
    dispatch(searchStoreActions.setSearchFilter(filterValue));
  };

  const handleKeywordSearchChange = (e: any) => {
    setKeyWord(e.currentTarget.value);
    setKeyWordSend(e.currentTarget.value);
  };

  const handleSelectSuggest = (e: IValueLabel<string>) => {
    setKeyWord(e);
  };

  useEffect(() => {
    setLoading(true);
    keywordSend !== "" &&
      homepageApi
        .getSuggets({
          area_keyword: "",
          keyword: keywordSend,
          threshold: 0.4,
        })
        .then((e) => setSuggests(e.data.body.data))
        .catch((error) => console.log(error));
    setLoading(false);
  }, [keywordSend]);

  return (
    <Box
      display="flex"
      border={1}
      borderRadius="3px"
      borderColor='divider'
      bgcolor="white"
      position="relative"
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="エリア・ジャンル・店名"
        value={keyword.label}
        onChange={handleKeywordSearchChange}
        onBlur={() => {
          setSuggests([]);
          setKeyWordSend("");
        }}
      />
      <Button
        variant="contained"
        sx={{
          borderRadius: "0px 2px 2px 0px",
        }}
        onClick={handleSearchClick}
      >
        <Search />
      </Button>

      {suggests && suggests.length > 0 && (
        <Box
          p={3}
          boxShadow={3}
          bgcolor="white"
          zIndex={7}
          position="absolute"
          right={0}
          left={0}
          top="100%"
        >
          {suggests.map((e) => (
            <>
              <Chip
                key={e.value}
                label={e.label}
                sx={{ m: 1, zIndex: 8 }}
                clickable
                onMouseDown={() => handleSelectSuggest(e)}
              />
            </>
          ))}
        </Box>
      )}
      {loading && (
        <Box p={3} bgcolor="#eee" zIndex={7} display="flex">
          <Skeleton
            variant="rounded"
            height="25px"
            width="50px"
            sx={{ m: 1 }}
          />
          <Skeleton
            variant="rounded"
            height="25px"
            width="70px"
            sx={{ m: 1 }}
          />
          <Skeleton
            variant="rounded"
            height="25px"
            width="30px"
            sx={{ m: 1 }}
          />
        </Box>
      )}
    </Box>
  );
}

export default SuggestSearchBar;
